import React from "react";
import "./Reason_cancelling_field_holder.css";
import { Form } from "react-bootstrap";
import Green_btn from "../common_btn/green_btn/Green_btn";
import { useDispatch } from "react-redux";
import {
  cancelOrder,
  replaceOrder,
  returnOrder,
} from "../../../features/order/orderSlice";
import { useNavigate } from "react-router-dom";
import { encodeId, variant_type } from "../../../utils/common";
import Success_Modal from "../common_modal/success_modal/Success_Modal";
import Gray_Btn from "../common_btn/gray_btn/Gray_Btn";
import Spinner from "react-bootstrap/Spinner";
import Replace_btn from "../common_btn/repalce_btn/Replace_btn";

function Reason_cancelling_field_holder({
  product,
  selectedVariant,
  setCancelReason,
  cancelReason,
  cancelReasonId,
  selectedItems,
  order,
  error,
  setError,
  type,
}) {
  const navigate = useNavigate();
  const [loader, setLoader] = React.useState(false);
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = React.useState(false);

  const isSameVariant = () => {
    if (Number(product?.variant_type_id) === Number(variant_type.Single)) {
      return Number(order?.variant_id) === Number(selectedVariant?.id);
    }

    if (Number(product?.variant_type_id) === Number(variant_type.Double)) {
      return Number(order?.d_variant_id) === Number(selectedVariant?.id);
    }

    if (Number(product?.variant_type_id) === Number(variant_type.Triple)) {
      return Number(order?.t_variant_id) === Number(selectedVariant?.id);
    }

    return false;
  };

  const handleClick = () => {
    setModalShow(true);

    setTimeout(() => {
      setModalShow(false);
      setLoader(true);
      navigate("/");
    }, 2000);
  };

  const onSubmit = async () => {
    const newErrors = {
      reason: "",
      product: "",
      variant: "",
    };

    // Validate reason
    if (cancelReasonId === null) {
      newErrors.reason =
        type === "Return"
          ? "Return Reason Required"
          : type === "Replace"
          ? "Replace Reason Required"
          : "Cancel Reason Required";
    }

    // Validate product
    if (
      (type === "Return" || type === "Cancel") &&
      selectedItems.length === 0
    ) {
      newErrors.product =
        type === "Return"
          ? "Select product to Return"
          : "Select product to Cancel";
    }

    // Validate replacement variant
    if (type === "Replace" && !selectedVariant) {
      newErrors.variant = "Please select a variant";
    }

    // Check same variant only if a variant has been selected
    if (type === "Replace" && selectedVariant) {
      if (isSameVariant()) {
        newErrors.variant =
          "Please select a different variant. The same product cannot be replaced.";
      }
    }

    // Set ALL errors together
    setError(newErrors);

    // Stop submission if any error exists
    if (newErrors.reason || newErrors.product || newErrors.variant) {
      return;
    }

    const data = {
      message: cancelReason,
      products: selectedItems,
    };

    let res;

    if (type === "Return") {
      setLoader(true);

      data.return_reason_id = cancelReasonId;

      res = await dispatch(
        returnOrder({
          order_id: order?.id,
          data,
        }),
      );
    }

    if (type === "Replace") {
      setLoader(true);

      data.product_id = product?.id;
      data.variant_type_id = product?.variant_type_id;
      data.replace_reason_id = cancelReasonId;

      if (Number(product.variant_type_id) === variant_type.Single) {
        data.variant_id = selectedVariant?.id;
      } else if (Number(product.variant_type_id) === variant_type.Double) {
        data.d_variant_id = selectedVariant?.id;
      } else if (Number(product.variant_type_id) === variant_type.Triple) {
        data.t_variant_id = selectedVariant?.id;
      }

      res = await dispatch(
        replaceOrder({
          order_id: order?.id,
          data,
        }),
      );
    }

    if (type === "Cancel") {
      setLoader(true);

      data.cancel_reason_id = cancelReasonId;

      res = await dispatch(
        cancelOrder({
          order_id: order?.id,
          data,
        }),
      );
    }

    if (res?.meta?.requestStatus === "fulfilled") {
      handleClick();
    } else if (res?.meta?.requestStatus === "rejected") {
      setLoader(false);
    }
  };

  const hasReturnableProduct = order?.Product_Order_Details?.some(
    (item) => item?.Product?.is_returnable,
  );

  return (
    <>
      <section className="Reason_cancelling_field_holder">
        <Form>
          <Form.Group
            className="input_group mb-3"
            controlId="exampleForm.ControlTextarea1"
          >
            <Form.Label>
              {type === "Cancel"
                ? "Could you tell us a reason for cancelling? (optional)"
                : type === "Return"
                ? "Could you tell us a reason for Returning? (optional)"
                : type === "Replace"
                ? "Could you tell us a reason for Replace? (optional)"
                : ""}
            </Form.Label>

            <Form.Control
              as="textarea"
              placeholder="Type a reason"
              rows={1}
              value={cancelReason || ""}
              onChange={(e) => {
                setCancelReason(e.target.value);
              }}
            />
          </Form.Group>

          <div className="btn_holder">
            {loader ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <>
                {type === "Return" ? (
                  <Replace_btn
                    btnText={"Submit"}
                    onClick={() => onSubmit()}
                    disabled={type === "Return" && !hasReturnableProduct}
                  />
                ) : (
                  <>
                    {(product?.variant_type_id === 1
                      ? selectedVariant?.general_stock
                      : selectedVariant?.stock) <= 0 ? (
                      <Green_btn btnText="Out Of Stock" />
                    ) : (
                      <Green_btn btnText="Submit" onClick={() => onSubmit()} />
                    )}
                  </>
                )}
              </>
            )}

            <Gray_Btn
              btnText={"Cancel"}
              onClick={() => navigate(`/order-details/${encodeId(order?.id)}`)}
            />
          </div>
        </Form>

        <Success_Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          successText={
            type === "Cancel"
              ? "Order Cancelled Successfully!"
              : type === "Return"
              ? "Order Return Successfully!"
              : "Order Replace Successfully!"
          }
        />
      </section>
    </>
  );
}

export default Reason_cancelling_field_holder;
